/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ActionDeleteResp } from '../models/action-delete-resp';
import { ActionDto } from '../models/action-dto';
import { ActionGetAllReq } from '../models/action-get-all-req';
import { ActionGetAllResp } from '../models/action-get-all-resp';

@Injectable({
  providedIn: 'root',
})
export class ActionService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation actionPut
   */
  static readonly ActionPutPath = '/actions';

  /**
   * Crear o actualizar producto
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `actionPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  actionPut$Response(params: {
    body: ActionDto
  }): Observable<StrictHttpResponse<{
'success'?: boolean;
}>> {

    const rb = new RequestBuilder(this.rootUrl, ActionService.ActionPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        'success'?: boolean;
        }>;
      })
    );
  }

  /**
   * Crear o actualizar producto
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `actionPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  actionPut(params: {
    body: ActionDto
  }): Observable<{
'success'?: boolean;
}> {

    return this.actionPut$Response(params).pipe(
      map((r: StrictHttpResponse<{
'success'?: boolean;
}>) => r.body as {
'success'?: boolean;
})
    );
  }

  /**
   * Path part for operation actionGetAll
   */
  static readonly ActionGetAllPath = '/actions';

  /**
   * Get all actions
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `actionGetAll()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  actionGetAll$Response(params: {

    /**
     * pagination load page
     */
    page?: number;
    body: ActionGetAllReq
  }): Observable<StrictHttpResponse<ActionGetAllResp>> {

    const rb = new RequestBuilder(this.rootUrl, ActionService.ActionGetAllPath, 'post');
    if (params) {
      rb.query('page', params.page, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ActionGetAllResp>;
      })
    );
  }

  /**
   * Get all actions
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `actionGetAll$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  actionGetAll(params: {

    /**
     * pagination load page
     */
    page?: number;
    body: ActionGetAllReq
  }): Observable<ActionGetAllResp> {

    return this.actionGetAll$Response(params).pipe(
      map((r: StrictHttpResponse<ActionGetAllResp>) => r.body as ActionGetAllResp)
    );
  }

  /**
   * Path part for operation actionDelete
   */
  static readonly ActionDeletePath = '/actions/{uuid}';

  /**
   * Eliminar un action
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `actionDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  actionDelete$Response(params: {

    /**
     * action uuid
     */
    uuid: string;
  }): Observable<StrictHttpResponse<ActionDeleteResp>> {

    const rb = new RequestBuilder(this.rootUrl, ActionService.ActionDeletePath, 'delete');
    if (params) {
      rb.path('uuid', params.uuid, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ActionDeleteResp>;
      })
    );
  }

  /**
   * Eliminar un action
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `actionDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  actionDelete(params: {

    /**
     * action uuid
     */
    uuid: string;
  }): Observable<ActionDeleteResp> {

    return this.actionDelete$Response(params).pipe(
      map((r: StrictHttpResponse<ActionDeleteResp>) => r.body as ActionDeleteResp)
    );
  }

}
